import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { verifyResetCode, useAppDispatch } from '../redux';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const VerifyResetCode = () => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await dispatch(verifyResetCode({ email, code })).unwrap();
      localStorage.setItem("resetEmail", email);
      localStorage.setItem("resetCode", code);
      navigate('/reset-password');
    } catch (error) {
      setError(
        typeof error === "string"
          ? error
          : error?.message || "Failed to verify reset code"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="container-fluid auth-container" style={{ minHeight: 'calc(100vh - 200px)', paddingTop: '10rem', paddingBottom: '8rem' }}>
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
          <div className="card p-4 shadow-lg" style={{ width: '100%', maxWidth: '400px' }}>
            <h3 className="text-center mb-4">Verify Reset Code</h3>
            
            <form onSubmit={handleSubmit}>
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email address</label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="code" className="form-label">Reset Code</label>
                <input
                  type="text"
                  id="code"
                  className="form-control"
                  placeholder="Enter the code sent to your email"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>

              <button 
                type="submit" 
                className="btn btn-primary w-100"
                disabled={loading}
              >
                {loading ? 'Verifying...' : 'Verify Code'}
              </button>

              <div className="text-center mt-3">
                <small className="text-muted">
                  Didn't receive the code? <Link to="/request-password-reset">Request Again</Link>
                </small>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default VerifyResetCode; 